import React from "react";

const BABASAHEB_URL =
  "/images/uz5is5jd-whatsapp-image-2026-05-06-at-05-19-10.jpeg";

/**
 * Painted portrait of Babasaheb Dr. B.R. Ambedkar.
 * The new portrait is a close-up head-and-shoulders, so we centre on the face by default.
 */
export default function BabasahebPortrait({
  className = "",
  aspect = "aspect-[4/5]",
  position = "50% 28%",
}) {
  return (
    <div
      className={`relative ${aspect} overflow-hidden rounded-sm border border-navy/10 bg-pearl ${className}`}
    >
      <img
        src={BABASAHEB_URL}
        alt="Babasaheb Dr. B.R. Ambedkar"
        style={{ objectPosition: position }}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 ring-1 ring-navy/10 pointer-events-none" />
    </div>
  );
}

export const BABASAHEB_IMG = BABASAHEB_URL;
